import script from "./third-party-correct-select.vue?vue&type=script&lang=ts&setup=true"
export * from "./third-party-correct-select.vue?vue&type=script&lang=ts&setup=true"

import "./third-party-correct-select.vue?vue&type=style&index=0&id=602301b1&scoped=true&lang=scss"

import exportComponent from "/var/lib/jenkins/workspace/qiyexinxi_app-after-sales_prod/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-602301b1"]])

export default __exports__